import { render, staticRenderFns } from "./orderStatus.vue?vue&type=template&id=4d5b1180&scoped=true&"
import script from "./orderStatus.vue?vue&type=script&lang=js&"
export * from "./orderStatus.vue?vue&type=script&lang=js&"
import style0 from "./orderStatus.vue?vue&type=style&index=0&id=4d5b1180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b1180",
  null
  
)

export default component.exports